export default __webpack_public_path__ + "static/media/spin-bg-10.61c76d96.png";